const map = {
	"./ChangiRecommends_Logo.jpg": 8954,
	"./ChangiRecommends_Logo.png": 1342,
	"./ChangiRecommends_Logo_favicon.jpg": 5107,
	"./ChangiRecommends_Logo_favicon.png": 3019,
	"./alco-mock/1.png": 3351,
	"./alco-mock/2.png": 2716,
	"./alco-mock/3.png": 2133,
	"./alco-mock/4.png": 7466,
	"./alco-mock/5.png": 6323,
	"./alco-mock/6.png": 1832,
	"./american-express-new.png": 6999,
	"./american-express.png": 5642,
	"./atome-yellow.png": 2894,
	"./atome.png": 9655,
	"./atome2.png": 5141,
	"./awardIcon.png": 1295,
	"./cart-item1.png": 3192,
	"./changirecommends-banner.jpg": 7295,
	"./changirecommends-logo-2.png": 7981,
	"./changirecommends_logo_lg.png": 7328,
	"./changirecommends_placeholder.jpg": 7704,
	"./changirecommends_placeholder.png": 8156,
	"./changirecommends_placeholder_old.jpg": 8318,
	"./chas-image-placeholder.png": 4894,
	"./chevron-down.png": 5549,
	"./chevron-up.png": 4358,
	"./cts-logo-new.png": 7338,
	"./electronics.png": 2442,
	"./esim-icon.png": 5279,
	"./facebook-f.svg": 3334,
	"./faq-banner-bg.png": 2886,
	"./icons8-telegram-48.png": 9492,
	"./icons8-tiktok-48.png": 7609,
	"./icons8-youtube-24.png": 3766,
	"./instagram.svg": 6149,
	"./linkedin-in.svg": 9879,
	"./maestro.png": 6396,
	"./mastercard-new.png": 2554,
	"./mastercard.png": 3983,
	"./my-account-dashboard.png": 1012,
	"./my-account-details.png": 5178,
	"./my-account-track-order.png": 7934,
	"./no-image-small-thumbnail.png": 5851,
	"./no-image-thumbnail.png": 2829,
	"./no-image.png": 7098,
	"./not_found_placeholder.jpg": 9123,
	"./paper-plane.svg": 7390,
	"./paynow.png": 3433,
	"./paynowQRMock.png": 5242,
	"./perfume.png": 1875,
	"./sample-product.png": 9359,
	"./samsung-logo.png": 8155,
	"./spot1.png": 242,
	"./spot2.png": 4249,
	"./spot3.png": 8496,
	"./twitter.svg": 6072,
	"./unionpay.png": 6334,
	"./visa-new.png": 7169,
	"./visa.png": 2244,
	"./wechatpay128.png": 9280,
	"./whisky.png": 7202
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3811;